import { crmRequest } from '../http'
import type { RelationRef } from '../timeline/types'
import type {
  Agreement,
  AgreementInput,
  Occurrence,
  OwnerTransfer,
  RelationAgreements,
  SchedulePreview,
} from './types'

function relationQuery(relation: RelationRef): string {
  const params = new URLSearchParams(
    relation.kind === 'contact' ? { person_id: relation.id } : { organisation_id: relation.id },
  )
  return params.toString()
}

const json = (body: unknown): RequestInit => ({ method: 'POST', body: JSON.stringify(body) })

export function listRelationAgreements(relation: RelationRef): Promise<RelationAgreements> {
  return crmRequest(`/agreements?${relationQuery(relation)}`)
}

export function getAgreement(id: string): Promise<Agreement> {
  return crmRequest(`/agreements/${id}`)
}

export function createAgreement(input: AgreementInput): Promise<Agreement> {
  return crmRequest('/agreements', json(input))
}

export function updateAgreement(id: string, patch: Partial<AgreementInput>): Promise<Agreement> {
  return crmRequest(`/agreements/${id}`, { method: 'PATCH', body: JSON.stringify(patch) })
}

export function deleteAgreement(id: string): Promise<void> {
  return crmRequest(`/agreements/${id}`, { method: 'DELETE' })
}

export function restoreAgreement(id: string): Promise<Agreement> {
  return crmRequest(`/agreements/${id}/restore`, json({}))
}

export function agreementAction(id: string, action: 'pause' | 'resume' | 'end'): Promise<Agreement> {
  return crmRequest(`/agreements/${id}/${action}`, json({}))
}

export function previewSchedule(
  input: Partial<AgreementInput> & { agreement_id?: string },
  signal?: AbortSignal,
): Promise<SchedulePreview> {
  return crmRequest('/agreements/schedule-preview', { ...json(input), signal })
}

export function listOccurrences(id: string): Promise<Occurrence[]> {
  return crmRequest(`/agreements/${id}/occurrences`)
}

export function completeOccurrence(id: string): Promise<Agreement> {
  return crmRequest(`/agreement-occurrences/${id}/complete`, json({}))
}

export function skipOccurrence(id: string): Promise<Agreement> {
  return crmRequest(`/agreement-occurrences/${id}/skip`, json({}))
}

export function postponeOccurrence(id: string, body: { days: 7 | 14 } | { due_date: string }): Promise<Agreement> {
  return crmRequest(`/agreement-occurrences/${id}/postpone`, json(body))
}

export function getOwnerTransfer(relation: RelationRef): Promise<OwnerTransfer> {
  return crmRequest(`/owner-transfer?${relationQuery(relation)}`)
}
